import { useRef, useEffect } from 'react';
import ReactPlayer from 'react-player';

const ViewDetails = ({
  dialogRef,
  closeDialog,
  selectedRoutine,
  openRoutineDialog,
}) => {
  const bottomRef = useRef(null);

  useEffect(() => {
    const clickOutsideDialog = (e) => {
      if (
        dialogRef.current.contains(e.target) &&
        !bottomRef.current.contains(e.target)
      ) {
        handleCancel();
      }
    };

    document.addEventListener('click', clickOutsideDialog);

    return () => {
      document.removeEventListener('click', clickOutsideDialog);
    };
  }, []);

  const handleCancel = () => {
    closeDialog();
  };

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-full bg-transparent'
      onCancel={handleCancel}
    >
      <div
        ref={bottomRef}
        className={`bg-secondary fixed bottom-0 w-full max-w-lg rounded-t-3xl px-3 pt-6 pb-3 flex flex-col overflow-y-auto scrollbar-hidden text-white border-t border-tertiary`}
      >
        <div className='flex items-center justify-between mb-4'>
          <h1 className='text-xl font-bold flex flex-wrap gap-1'>
            {selectedRoutine?.routine?.title}
          </h1>
          <button
            onClick={handleCancel}
            className='text-2xl'
          >
            🅧
          </button>
        </div>
        {selectedRoutine && (
          <div className='relative flex items-start justify-start gap-4 overflow-x-auto scrollbar-hidden'>
            {selectedRoutine.routine.sets.map((s, j) => (
              <div
                key={j}
                className='flex-shrink-0 bg-tertiary rounded-xl p-4'
              >
                <div className='flex items-center gap-2'>
                  {s.exercises.map((exe, k) => (
                    <div
                      key={k}
                      className='aspect-[9/16] h-48 overflow-hidden rounded-xl'
                    >
                      <ReactPlayer
                        key={k}
                        url={exe.vodUrl}
                        width='100%'
                        height='100%'
                        muted={true}
                        loop={true}
                        playsinline={true}
                        playing={true}
                      />
                    </div>
                  ))}
                </div>
                {selectedRoutine.routine.cycleRoutine ? (
                  <div className='text-sm mt-2'>
                    {s.exercises.map((exe, k) => (
                      <div key={k}>{exe.name}</div>
                    ))}
                  </div>
                ) : (
                  <div className='flex gap-2 text-sm mt-2'>
                    <div className='flex-1'>
                      {s.exercises.map((exe, k) => (
                        <div key={k}>{exe.name}</div>
                      ))}
                    </div>
                    <div className='text-xs text-white/50 self-end'>
                      x {s.setCount} sets
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        <button
          className='rounded-full py-2 bg-accent font-bold text-black w-full my-4'
          onClick={() => {
            handleCancel();
            openRoutineDialog();
          }}
        >
          Start Workout
        </button>
      </div>
    </dialog>
  );
};

export default ViewDetails;
